import { ShippingMethodPropertyMetadata } from './shipping-method-property-metadata';
import { ShippingMethodPropertyCode } from '../enums/shipping-method-property-code';
import { executeOrNull, Nillable, valueOrNull } from '@web/utils';
import { ShippingMethodPropertyMetadataCode } from '../enums/shipping-method-property-metadata-code';

export class ShippingMethodProperty {
  public constructor(
    private readonly data: {
      code: ShippingMethodPropertyCode;
      name: string;
      value: string;
      metadata: ShippingMethodPropertyMetadata[];
    },
  ) {
    this.data = data;
  }

  public get code(): ShippingMethodPropertyCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get value(): string {
    return this.data.value;
  }

  public get metadata(): ShippingMethodPropertyMetadata[] {
    return this.data.metadata;
  }

  public get description(): Nillable<string> {
    return valueOrNull(
      this.data.metadata.find(
        (item) => item.code === ShippingMethodPropertyMetadataCode.Description,
      )?.value,
    );
  }

  public get longitude(): Nillable<number> {
    const metadata = this.data.metadata.find(
      (item) => item.code === ShippingMethodPropertyMetadataCode.Longitude,
    );

    return executeOrNull(metadata?.value, (result) => Number(result));
  }

  public get latitude(): Nillable<number> {
    const metadata = this.data.metadata.find(
      (item) => item.code === ShippingMethodPropertyMetadataCode.Latitude,
    );

    return executeOrNull(metadata?.value, (result) => Number(result));
  }
}
